import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// The retired static site routed on hash fragments (e.g. #/platform). Rewrite
// any legacy #/path hash to a real path before the router mounts, so old
// bookmarks/indexed links land on the right page instead of silently falling
// through to the homepage. Plain in-page anchors (e.g. #open-roles) don't
// start with #/ and are left alone, matching the old site's own routing rule.
const legacyHash = window.location.hash.match(/^#\/(.*)$/);
if (legacyHash) {
  window.history.replaceState(null, '', `/${legacyHash[1]}${window.location.search}`);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
